export default __webpack_public_path__ + "static/media/nav-arrow-left.0f6a405a.svg";